import { Translator } from 'Translator';

export class UrlHelper {
  static getBaseUrl(withLangCode = true) {
    if (withLangCode) {
      const langCode = Translator.getLanguageCode();
      return `${URL_HOST}${langCode === 'en' ? '' : '/' + langCode}`;
    }
    return URL_HOST;
  }

  static url(path, withLangCode = true) {
    return UrlHelper.getBaseUrl(withLangCode) + path;
  }

  static localizedLink(to) {
    const langCode = Translator.getLanguageCode();
    const toWithSlash = to.startsWith('/') ? to : `/${to}`;
    const localizedTo = `${
      langCode !== 'en' && !to.startsWith(`/${langCode}/`) ? `/${langCode}` : ''
    }${toWithSlash}`;
    return localizedTo;
  }

  static getLocationSearchUrl(country, city) {
    const formattedCountry = country.toLowerCase().split(' ').join('-');
    const formattedCity = city.toLowerCase().split(' ').join('-');
    return `/experiences/${formattedCountry}/${formattedCity}/`;
  }
}
